import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, useLocalizeMessage, ModalDialog } from 'libs.nucleus';
import { useBooleanState } from 'libs.react';
export const ViewErrorLogAction = ({ error_message }) => {
    const translate = useLocalizeMessage();
    const [isDialogOpen, openDialog, closeDialog] = useBooleanState(false);
    return (_jsxs("div", { className: 'flex justify-center', children: [_jsx(Button, { variant: 'transparent', label: translate('See logs'), onClick: () => {
                    openDialog();
                } }), isDialogOpen && (_jsx(ModalDialog, { title: translate('Error logs'), body: error_message, actionButtons: [
                    {
                        label: translate('Ok'),
                        onClick: closeDialog,
                    },
                ], isOpen: true, closeDialog: closeDialog }))] }));
};
